import { useState, useRef, useEffect } from 'react'
import '../css/Document.css'
import Vitae from './Document/Vitae'

function Document({ field, design, modeHandler }) {
   const [position, setPosition] = useState({ x: 0, y: 0 })
   const [scale, setScale] = useState(0.75)
   const [activeMode, setActiveMode] = useState('fields')

   const containerRef = useRef(null)
   const vitaeRef = useRef(null)
   const isDragging = useRef(false)
   const lastMousePos = useRef({ x: 0, y: 0 })

   /* Non-passive wheel — required so preventDefault actually works */
   useEffect(() => {
      const el = containerRef.current
      if (!el) return
      function onWheel(e) {
         e.preventDefault()
         setScale(s => Math.min(Math.max(s - e.deltaY * 0.001, 0.3), 3))
      }
      el.addEventListener('wheel', onWheel, { passive: false })
      return () => el.removeEventListener('wheel', onWheel)
   }, [])

   function handleMouseDown(e) {
      if (
         e.target.closest('.switch-buttons') ||
         e.target.closest('.export-btn')
      )
         return
      isDragging.current = true
      lastMousePos.current = { x: e.clientX, y: e.clientY }
   }

   function handleMouseMove(e) {
      if (!isDragging.current) return
      const dx = e.clientX - lastMousePos.current.x
      const dy = e.clientY - lastMousePos.current.y
      lastMousePos.current = { x: e.clientX, y: e.clientY }
      setPosition(prev => ({ x: prev.x + dx, y: prev.y + dy }))
   }

   function handleMouseUp() {
      isDragging.current = false
   }

   function switchMode(m) {
      setActiveMode(m)
      modeHandler(m)
   }

   async function handleExport() {
      const el = vitaeRef.current
      if (!el) return
      const prev = {
         transform: el.style.transform,
         transition: el.style.transition,
      }
      el.style.transform = 'none'
      el.style.transition = 'none'
      const { default: html2canvas } =
         await import('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.esm.js')
      const canvas = await html2canvas(el, {
         scale: 2,
         useCORS: true,
         backgroundColor: '#ffffff',
         logging: false,
      })
      Object.assign(el.style, prev)
      const a = document.createElement('a')
      a.download = `resume-${Date.now()}.png`
      a.href = canvas.toDataURL('image/png')
      a.click()
   }

   return (
      <div
         ref={containerRef}
         className="document"
         style={{ cursor: isDragging.current ? 'grabbing' : 'grab' }}
         onMouseDown={handleMouseDown}
         onMouseMove={handleMouseMove}
         onMouseUp={handleMouseUp}
         onMouseLeave={handleMouseUp}>
         <div className="switch-buttons">
            <span
               className={activeMode === 'fields' ? 'active' : ''}
               onClick={() => switchMode('fields')}>
               Form
            </span>
            <span
               className={activeMode === 'customize' ? 'active' : ''}
               onClick={() => switchMode('customize')}>
               Design
            </span>
         </div>

         <button
            className="export-btn"
            onClick={handleExport}
            title="Export as PNG">
            <svg
               viewBox="0 0 16 16"
               fill="none"
               stroke="currentColor"
               strokeWidth="1.5"
               strokeLinecap="round"
               strokeLinejoin="round">
               <path d="M8 2v8M5 7l3 3 3-3" />
               <path d="M2 12v1a1 1 0 001 1h10a1 1 0 001-1v-1" />
            </svg>
            Export
         </button>

         <Vitae
            ref={vitaeRef}
            field={field}
            design={design}
            style={{
               transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
               transition: 'transform 0.1s ease-out',
            }}
         />
      </div>
   )
}

export default Document
